import { createElement, type FC, type ReactElement } from 'react';
import { FormFieldType } from '../../../typings';
import type { SingleFieldInnerRenderProps } from './single-field-inner-presenter.types';

export type SingleFieldInnerRenderer = FC<SingleFieldInnerRenderProps>;

class SingleFieldInnerPresenterRegistry {
  private readonly renderers = new Map<
    FormFieldType,
    SingleFieldInnerRenderer
  >();

  private fallbackRenderer: SingleFieldInnerRenderer | null = null;

  setFallback(renderer: SingleFieldInnerRenderer): this {
    this.fallbackRenderer = renderer;
    return this;
  }

  register(type: FormFieldType, renderer: SingleFieldInnerRenderer): this {
    this.renderers.set(type, renderer);
    return this;
  }

  render(
    type: FormFieldType,
    props: SingleFieldInnerRenderProps,
  ): ReactElement | null {
    const Renderer =
      this.renderers.get(type) ?? this.fallbackRenderer;
    if (!Renderer) {
      throw new Error(
        'SingleFieldInnerPresenterRegistry: fallback renderer not initialized',
      );
    }
    return createElement(Renderer, props);
  }
}

export const singleFieldInnerPresenterRegistry =
  new SingleFieldInnerPresenterRegistry();
